import { jobStatus } from '$variables/constants';

const checkExportJobInProgress = ({ status } = {}) =>
  status === jobStatus.START || status === jobStatus.PROCESSING;

export default checkExportJobInProgress;
